import { useEffect, useState } from 'react';
import { Iconsvg } from '@wk/components-react16';
import "./dashboard.scss"
import { useNavigate } from 'react-router-dom';
import PromptStudio from '../prompt/model/PromptStudio';
import HttpService from "../../config/http.service";
import { API_USER } from '../../config/constants';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';

const Dashboard = () => {
	const { authProject } = useSelector((state: RootState) => state.auth);
	const navigate = useNavigate();
	const promptObj = {
		id: null,
		name: '',
		text: '',
		promptType: null,
		jsonOutput: false,
		score: 0,
		categoryScore: null,
		tags: []
	};
	const [prompt, setPrompt] = useState(promptObj);
	const [promptTotal, setPromptTotal] = useState( 0 as any);
	const [projectTotal, setProjectTotal] = useState( 0 as any);
	const [validationRulesTotal, setValidationRulesTotal] = useState( 0 as any);
	const [isOpenPromptStudio, setIsOpenPromptStudio] = useState(false);
	const [isLoad, setIsLoad] = useState(false);
	const [userDefinedPromptType, setUserDefinedPromptType] = useState(false);
	const [isOpenImproveScore, setIsOpenImproveScore] = useState(false);

	const addPrompt = (type: boolean) => {
		setPrompt(promptObj);
		setIsOpenPromptStudio(true);
		if (type) {
			setUserDefinedPromptType(true);
		}
	}

	const handleRunDocument = () => {
		navigate("/rundocument");
	};


	const getDashboardData = () => {
		const queryParams = new URLSearchParams({ projectCode: authProject?.code ?? '' });
		HttpService.getRequest(`${API_USER.GET_DASHBOARD_DATA}?${queryParams.toString()}`).then(
			(res: any) => {
				setPromptTotal(res.promptCount);
				setValidationRulesTotal(res.validationRuleCount);
				setProjectTotal(res.projectCount)
			},
			(err: any) => {
			},
		)
	}

	useEffect(() => {
			getDashboardData();
			setIsLoad(false);
	}, [isLoad, authProject]);


	return (
		<section className='pt-10 pl-20 pr-20 pb-10'>
			<h4>Dashboard</h4>
			<div className="wk-grid-page-container mt-20 mb-20 p-0">
				<div className="wk-grid mb-30">
					<div className="wk-column-6 pr-10">
						<div className="p-30 wk-card-container mb-0 rounded-3 box-shadow">
							<div className="d-flex" 
								style={{ cursor: 'pointer' }}
								onClick={() => navigate("/prompt")}>
								<div className="card-icon1" style={{ backgroundColor: 'rgb(148,12,114,0.2)' }}>
									<Iconsvg name="portfolios" color="#940c72" size={25}></Iconsvg>
								</div>
								<div className="display-6 fw-500 card-title1 ml-20" style={{ color: '#940c72' }}>
									Prompts
								</div>
								<div className="ms-auto display-6" style={{ color: '#940c72' }}>{promptTotal}</div>
							</div>
							<hr className="divider" style={{ width: '100px', backgroundColor: '#940c72' }} />
							<div className='wk-size-3 mb-5'>Actions</div>
							<div className="d-flex justify-content-between">
								<button type="button" className="btn btn-outline-success" style={{ width: '45%' }} onClick={() => addPrompt(false)}>Create Prompt{' '}
									<Iconsvg name="arrow-right"></Iconsvg></button>
								<button type="button" className="btn btn-outline-warning" style={{ width: '45%' }} onClick={() => addPrompt(true)}>Create Guided Prompt{' '}<Iconsvg name="arrow-right"></Iconsvg></button>
							</div>
						</div>
					</div>

					<div className="wk-column-6 pl-10">
						<div className="p-30 wk-card-container rounded-3 border box-shadow">
							<div className="d-flex">
								<div className="card-icon2" style={{ backgroundColor: 'rgb(133,188,32,0.2)' }}>
									<Iconsvg name="file" color="#85BC20" size={25}></Iconsvg>
								</div>
								<div className="display-6 fw-500 card-title2 ml-20" style={{ color: '#85BC20' }}>
									Documents
								</div>
								<div className="ms-auto display-6" style={{ color: '#85BC20' }}></div>
							</div>
							<hr className="divider" style={{ width: '100px', backgroundColor: '#85BC20' }} />
							<div className='wk-size-3 mb-5'>Actions</div>
							<div className="d-flex justify-content-between">
								<button type="button" className="btn btn-outline-primary" style={{ width: '45%' }} onClick={() => handleRunDocument()}>Run Document{' '}
									<Iconsvg name="arrow-right"></Iconsvg></button>
								<button type="button" className="btn btn-outline-secondary"  style={{ width: '45%' }} onClick={() => navigate("/multi-run-prompt")}>Bulk Prompt Run{' '}
									<Iconsvg name="arrow-right"></Iconsvg></button>
							</div>
							{/* <div className="mt-10 text-center">
								<button type="button" className="btn btn-warning-warning" disabled={true} style={{ width: '45%' }}>Multi-Language{' '}
									<Iconsvg name="arrow-right"></Iconsvg></button>
							</div> */}
						</div>
					</div>
				</div>
				<div className="wk-grid mb-30">
					<div className="wk-column-6 pr-10">
						<div className="p-30 wk-card-container rounded-3 border box-shadow" 
							role="link"
							style={{ cursor: 'pointer' }}
							onClick={() => navigate("/validationrule")}
							onKeyDown={(event) => {
								if (event.key === "Enter" || event.key === " ") {
									event.preventDefault();
									navigate("/validationrule");
								}
							}}
							>
							<div className="d-flex">
								<div className="card-icon2" style={{ backgroundColor: 'rgb(229,32,46,0.2)' }}>
									<Iconsvg name="list-bullet-check" color="#E5202E" size={25}></Iconsvg>
								</div>
								<div className="display-6 fw-500 card-title2 ml-20" style={{ color: '#E5202E' }}>
									Validation Library
								</div>
								<div className="ms-auto display-6" style={{ color: '#E5202E' }}>{validationRulesTotal}</div>
							</div>
						</div>
					</div>
					<div className="wk-column-6 pl-10">
						<div
							className="p-30 wk-card-container rounded-3 border box-shadow"
							role="link"
							tabIndex={0}
							style={{ cursor: 'pointer' }}
							onClick={() => navigate("/chat")}
							onKeyDown={(event) => {
								if (event.key === "Enter" || event.key === " ") {
									event.preventDefault();
									navigate("/chat");
								}
							}}
						>
							<div className="d-flex">
								<div className="card-icon2" style={{ backgroundColor: 'rgb(53,53,53,0.2)' }}>
									<Iconsvg name="layer" color="#353535" size={25}></Iconsvg>
								</div>
								<div className="display-6 fw-500 card-title2 ml-20" style={{ color: '#353535' }}>
									Interactive Chat
								</div>
								{/* <div className="ms-auto display-6" style={{ color: '#353535' }}>{projectTotal}</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>
			{isOpenPromptStudio && <PromptStudio data={{ isOpenPromptStudio, setIsOpenPromptStudio, prompt, setPrompt, setIsLoad, promptObj, userDefinedPromptType, setUserDefinedPromptType, isOpenImproveScore, setIsOpenImproveScore }} />}
		</section>
	);
};

export default Dashboard;
